// src/components/Form/LeaveType.jsx - Full and Complete
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaArrowLeft, FaPlus, FaEdit, FaTrash, FaCalendarAlt, FaCheckCircle, FaExclamationTriangle, FaCog , FaBuilding, FaMapMarkerAlt, FaTimes} from 'react-icons/fa';
import { checkIsAdmin, checkIsGlobalAdmin } from "../../utils/authUtils";
import CustomerCustomizationModal from "./CustomerCustomizationModal";
import useCustomization from '../../hooks/useCustomization';
import { UserContext } from '../../Context/UserContext';
import './CreateCustomerPage.css';

const LeaveType = () => {
  const navigate = useNavigate();
  const { visibleFields, isFieldVisible, handleCustomizationRefresh } = useCustomization('Leave Type');
  const { getHeaders } = useContext(UserContext);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [form, setForm] = useState({
    leave_code: '',
    leave_name: '',
    is_paid: true,
    allow_half_day: false,
    allow_hourly: false,
    description: '',
    is_active: true
  });
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [baseUrl, setBaseUrl] = useState('');
  const [originalCompany, setOriginalCompany] = useState("");
  const [isCompanyAdmin, setIsCompanyAdmin] = useState(false);
  const [isGroupAdmin, setIsGroupAdmin] = useState(false);
  const activeBranchLocalUI = (localStorage.getItem('active_branch') || 'All Branches').trim();
  const isSpecificBranchActiveUI = activeBranchLocalUI.toLowerCase() !== 'all branches' && activeBranchLocalUI.toLowerCase() !== 'all' && activeBranchLocalUI !== '';
  const showCompanyAssign = !isSpecificBranchActiveUI && (isGroupAdmin || isCompanyAdmin);
  const showBranchAssign = !isSpecificBranchActiveUI && (isGroupAdmin || isCompanyAdmin);
  const [availableBranches, setAvailableBranches] = useState([]);
  const [allCompanies, setAllCompanies] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [selectedAddBranches, setSelectedAddBranches] = useState([]);
  const [selectedBranchFilter, setSelectedBranchFilter] = useState('');
  const [showCustomizeModal, setShowCustomizeModal] = useState(false);
  const [showAssignmentModal, setShowAssignmentModal] = useState(false);

  // Permission State
  const [canWrite, setCanWrite] = useState(false);
  const [canDelete, setCanDelete] = useState(false);

  // Fetch Permissions
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const userStr = localStorage.getItem('user');
        if (userStr) {
          const userObj = JSON.parse(userStr);
          const role = userObj.role || userObj.UserType || "";
          const roleNorm = role.toLowerCase().replace(/[\s_]/g, '');
          const isGA = checkIsGlobalAdmin(userObj);
          const isCA = roleNorm === 'companyadmin' || roleNorm === 'admin' || roleNorm === 'manager';
          
          const isAdmin = isGA || isCA;
          setIsCompanyAdmin(isAdmin);
          setIsGroupAdmin(isGA);

          if (isAdmin) {
            setCanWrite(true);
            setCanDelete(true);
          }

          const activeContext = localStorage.getItem('active_company');
          let comps = [];
          const user = userObj;
          if (user.companies && user.companies.length > 0) {
            comps = user.companies.map(c => typeof c === 'object' && c !== null ? (c.company_name || c.company || c.name || '') : c).filter(c => c && typeof c === 'string');
          } else if (user.company_name || user.company) {
            comps = [user.company_name || user.company];
          } else {
            const currentBaseUrl = baseUrl || '';
            const res = await axios.get(`${currentBaseUrl}/api/company-details`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
            const details = res.data.companyDetails || [];
            comps = details.map(d => d.restaurantName || d.company_name).filter(n => n);
          }
          const finalComps = comps.length > 0 ? [...new Set(comps)] : [];
          setAllCompanies(finalComps);

          if (activeContext && activeContext !== 'All') {
            setSelectedCompanies([activeContext || user.company_name || ""]);
          } else if (activeContext === 'All' || !activeContext) {
            setSelectedCompanies([]); // Let user select in the modal
          }

          if (role) {
            const headers = {};
            if (userObj.company || userObj.company_name) headers['X-Company-Name'] = userObj.company || userObj.company_name;
            if (userObj.branch || userObj.branch_name) headers['X-Branch-Name'] = userObj.branch || userObj.branch_name;

            const url = baseUrl ? `${baseUrl}/api/role-permissions?role=${role}` : `/api/role-permissions?role=${role}`;
            const response = await axios.get(url, { headers });
            const perms = response.data.permissions || [];
            const pagePerm = perms.find(p => p.pageId === 'leave_types');
            if (pagePerm) {
              setCanWrite(pagePerm.canWrite === true);
              setCanDelete(pagePerm.canDelete === true);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    };



    const fetchBranches = async () => {
      try {
        const userStr = localStorage.getItem('user');
        const headers = {};
        if (userStr) {
          const userData = JSON.parse(userStr);
          if (userData.company_name) headers['X-Company-Name'] = userData.company_name;
        }
        const currentBaseUrl = baseUrl || '';
        const response = await axios.get(`${currentBaseUrl}/api/branches`, { headers });
        const branchData = response.data.map(b => typeof b === 'string' ? b : (b.branch_name || b.branch || b.name));
        setAvailableBranches(branchData);
      } catch (error) {
        console.error('Error fetching branches:', error);
      }
    };

    fetchPermissions();
    fetchBranches();
  }, [baseUrl, selectedBranchFilter]);

  // Fetch baseUrl on component mount
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await axios.get("/api/network_info");
        const { config: appConfig } = response.data;
        if (appConfig.mode === "client") {
          setBaseUrl(`http://${appConfig.server_ip}:6034`);
        } else {
          setBaseUrl('');
        }
      } catch (error) {
        console.error("Failed to fetch config:", error);
        setBaseUrl(window.location.origin || '');
      }
    };
    fetchConfig();
  }, []);

  const baseUrlResolved = baseUrl || '';

  useEffect(() => {
    if (baseUrlResolved !== undefined) {
      fetchLeaveTypes();
    }
  }, [baseUrlResolved]);

  const fetchLeaveTypes = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseUrlResolved}/api/leave-types`, { headers: getHeaders() });
      setLeaveTypes(res.data || []);
      setError('');
    } catch (err) {
      console.error('Error fetching leave types:', err);
      // Don't show error if it's just empty (though usually API returns empty list, not error)
      if (err.response && err.response.status !== 404) {
        setError('Failed to load leave types. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!canWrite) {
      setError("You do not have permission to manage leave types.");
      setTimeout(() => setError(''), 3000);
      return;
    }

    // Open Assign Modal if company/branch assignment is shown, otherwise process directly
    if (showCompanyAssign || showBranchAssign) {
      setShowAssignModal(true);
    } else {
      processSubmit();
    }
  };

  const processSubmit = async () => {
    const activeContext = localStorage.getItem('active_company');
    const userStr = localStorage.getItem('user');
    const userData = userStr ? JSON.parse(userStr) : null;
    const userComp = userData ? userData.company_name || userData.company || '' : '';
    
    let companiesToProcess = selectedCompanies;
    let branchesToProcess = selectedAddBranches;

    const activeBranchLocal = (localStorage.getItem('active_branch') || 'All Branches').trim();
    const isSpecificBranchActive = activeBranchLocal.toLowerCase() !== 'all branches' && activeBranchLocal.toLowerCase() !== 'all' && activeBranchLocal !== '';

    if (!showCompanyAssign) {
      companiesToProcess = activeContext === 'All' 
        ? selectedCompanies 
        : [activeContext || userComp].filter(Boolean);
    }

    if (!showBranchAssign) {
      branchesToProcess = isSpecificBranchActive ? [activeBranchLocal] : (selectedAddBranches.length > 0 ? selectedAddBranches : [userData?.branch_name || 'All Branches']);
    }

    setLoading(true);
    setError('');
    setShowAssignModal(false);

    try {
      const headers = { 'Content-Type': 'application/json' };
      if (companiesToProcess[0]) headers['X-Company-Name'] = companiesToProcess[0];
      if (branchesToProcess[0]) headers['X-Branch-Name'] = branchesToProcess[0];

      const payload = { 
        ...form, 
        company_names: companiesToProcess, 
        branch_names: branchesToProcess 
      };

      if (editingId && form.global_ref_id) {
        await axios.put(`${baseUrlResolved}/api/leave-types/bulk/${form.global_ref_id}`, payload, { headers });
        setMessage('Leave type updated across selected companies/branches successfully!');
      } else if (editingId) {
        await axios.put(`${baseUrlResolved}/api/leave-types/${editingId}`, payload, { headers });
        setMessage('Leave type updated successfully!');
      } else {
        await axios.post(`${baseUrlResolved}/api/leave-types`, payload, { headers });
        setMessage('Leave type created across selected companies/branches successfully!');
      }

      setTimeout(() => setMessage(''), 2000);
      clearForm();
      fetchLeaveTypes();
    } catch (err) {
      setError(err.response?.data?.error || 'Operation failed. Please try again.');
      setTimeout(() => setError(''), 3000);
    } finally {
      setLoading(false);
    }
  };

  const handleCompanyToggle = (company) => {
    setSelectedCompanies(prev =>
      prev.includes(company) ? prev.filter(c => c !== company) : [...prev, company]
    );
  };

  const handleEdit = (type) => {
    setForm({
      leave_code: type.leave_code || '',
      leave_name: type.leave_name,
      is_paid: type.is_paid,
      allow_half_day: type.allow_half_day,
      allow_hourly: type.allow_hourly,
      description: type.description || '',
      is_active: type.is_active,
      global_ref_id: type.global_ref_id || type._id
    });
    setEditingId(type.leave_type_id || type._id);
    setOriginalCompany(type.company_name || "");
    
    if (type.global_ref_id) {
      const related = leaveTypes.filter(lt => lt.global_ref_id === type.global_ref_id);
      const comps = [...new Set(related.map(lt => lt.company_name))].filter(Boolean);
      const brs = [...new Set(related.map(lt => lt.branch_name))].filter(b => b && b !== 'All Branches');
      setSelectedCompanies(comps);
      setSelectedAddBranches(brs);
    } else if (type.company_name) {
      setSelectedCompanies([type.company_name]);
      if (type.branch_name && type.branch_name !== 'All Branches') {
        setSelectedAddBranches([type.branch_name]);
      } else {
        setSelectedAddBranches([]);
      }
    }
  };

  const handleDelete = (id) => {
    setDeletingId(id);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = async () => {
    if (!canDelete) {
      setError("You do not have permission to delete leave types.");
      setTimeout(() => setError(''), 3000);
      setShowDeleteConfirm(false);
      return;
    }
    try {
      setLoading(true);
      const typeToDelete = leaveTypes.find(lt => (lt.leave_type_id || lt._id) === deletingId);
      const globalRef = typeToDelete ? typeToDelete.global_ref_id : null;
      
      const userStr = localStorage.getItem('user');
      const userData = userStr ? JSON.parse(userStr) : null;
      const headers = { 'Content-Type': 'application/json' };
      if (userData) {
        if (userData.company_name) headers['X-Company-Name'] = userData.company_name;
        const branchToUse = selectedBranchFilter || userData.branch_name;
        if (branchToUse) headers['X-Branch-Name'] = branchToUse;
      }
      
      const currentCompanyContext = localStorage.getItem('active_company');
      const currentBranchContext = localStorage.getItem('active_branch');
      if (currentCompanyContext && currentCompanyContext !== 'All') {
        headers['X-Company-Name'] = currentCompanyContext;
      }
      if (currentBranchContext && currentBranchContext !== 'All Branches') {
        headers['X-Branch-Name'] = currentBranchContext;
      }

      if (globalRef) {
        await axios.delete(`${baseUrlResolved}/api/leave-types/bulk/${globalRef}`, { headers });
      } else {
        await axios.delete(`${baseUrlResolved}/api/leave-types/${deletingId}`, { headers });
      }

      setMessage('Leave type deleted successfully!');
      setTimeout(() => setMessage(''), 2000);
      closeDeleteConfirm();
      fetchLeaveTypes();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to delete leave type.');
      setTimeout(() => setError(''), 3000);
    } finally {
      setDeletingId(null);
      setShowDeleteConfirm(false);
      setLoading(false);
    }
  };

  const closeDeleteConfirm = (e) => {
    if (e && e.target !== e.currentTarget) return;
    setShowDeleteConfirm(false);
    setDeletingId(null);
  };

  const clearForm = () => {
    setForm({
      leave_code: '',
      leave_name: '',
      is_paid: true,
      allow_half_day: false,
      allow_hourly: false,
      description: '',
      is_active: true,
      global_ref_id: ''
    });
    setEditingId(null);
    setMessage('');
    setError('');
    setSelectedCompanies([]);
    setSelectedAddBranches([]);
  };


  useEffect(() => {
    const fetchDynamicBranches = async () => {
      try {
        const url = baseUrl || "";
        const compsToFetch = selectedCompanies.length > 0 ? selectedCompanies : allCompanies;
        if (!compsToFetch || compsToFetch.length === 0) {
          return;
        }
        
        const localGetHeaders = () => {
          const token = localStorage.getItem('token');
          return token ? { Authorization: `Bearer ${token}` } : {};
        };
        const headersFunc = typeof getHeaders === 'function' ? getHeaders : localGetHeaders;

        const branchPromises = compsToFetch.map(comp => 
          axios.get(`${url}/api/branches?company_name=${encodeURIComponent(comp)}`, {
            headers: { ...headersFunc(), "X-Company-Name": comp }
          }).then(res => res.data)
        );
        
        const results = await Promise.all(branchPromises);
        const allBranches = [];
        results.forEach(data => {
          const branches = data.map(b => typeof b === 'string' ? b : (b.branch_name || b.branch || b.name)).filter(Boolean);
          allBranches.push(...branches);
        });
        
        setAvailableBranches([...new Set(allBranches)]);
      } catch (err) {
        console.error("Error fetching dynamic branches:", err);
      }
    };
    fetchDynamicBranches();
  }, [selectedCompanies, allCompanies, baseUrl]);
  if (loading && leaveTypes.length === 0) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #ffffff 0%, #3498db 100%)'
      }}>
        <div style={{
          textAlign: 'center',
          color: '#3498db',
          fontSize: '18px'
        }}>
          <FaCalendarAlt style={{ fontSize: '48px', marginBottom: '20px', color: '#3498db' }} />
          <p>Loading leave types...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="create-customer-container main-customer-page">
      <div className="customer-header-section">
        <div className="header-left">
          <button onClick={() => navigate('/admin')} className="header-back-btn" disabled={loading}>
            <FaArrowLeft /> Back
          </button>
        </div>

        <div className="header-center">
          <h1>Leave Type Master ({leaveTypes.length})</h1>
        </div>

        <div className="header-right">
          <div className="header-actions">
            {(isGroupAdmin || isCompanyAdmin) && (
              <button onClick={() => setShowCustomizeModal(true)} className="save-btn" style={{ backgroundColor: '#00d284', width: 'auto', padding: '0 20px' }} disabled={loading}>
                <FaCog /> Customize
              </button>
            )}
            <button onClick={() => navigate('/leave-allocation')} className="save-btn" style={{ backgroundColor: '#4B76E6', width: 'auto', padding: '0 20px' }} disabled={loading}>
              <FaCalendarAlt /> Go to Leave Allocation
            </button>
            <button type="submit" form="leaveTypeForm" disabled={loading || !form.leave_code || !form.leave_name} className="save-btn" style={{ backgroundColor: '#20c997', width: 'auto', padding: '0 20px' }}>
              {loading ? 'Saving...' : editingId ? 'Update Leave Type' : 'Create Leave Type'}
            </button>
          </div>
        </div>
      </div>

      <div className="customer-scroll-body">
        <div className="form-sections-wrapper">
          {/* Messages */}
        {error && (
          <div style={{ background: '#fef2f2', color: '#ef4444', padding: '16px 20px', borderRadius: '14px', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '12px', fontWeight: '600', border: '1px solid #fee2e2' }}>
            <FaExclamationTriangle style={{ fontSize: '20px' }} /> {error}
          </div>
        )}
        {message && (
          <div onClick={() => setMessage('')} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.75)', backdropFilter: 'blur(8px)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999, cursor: 'pointer' }}>
            <div onClick={(e) => e.stopPropagation()} style={{ background: '#ffffff', padding: '40px 32px', borderRadius: '24px', width: '90%', maxWidth: '440px', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', animation: 'modalScaleIn 0.3s cubic-bezier(0.16, 1, 0.3, 1)', cursor: 'default' }}>
              <div style={{ width: '84px', height: '84px', borderRadius: '50%', background: '#ecfdf5', color: '#10b981', border: '2px solid #a7f3d0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '38px', marginBottom: '24px', boxShadow: '0 10px 25px -5px rgba(16, 185, 129, 0.2)' }}>
                <FaCheckCircle />
              </div>
              <h3 style={{ fontSize: '24px', fontWeight: '800', color: '#1e293b', margin: '0 0 12px 0' }}>Success</h3>
              <p style={{ fontSize: '16px', color: '#64748b', margin: '0', fontWeight: '500' }}>{message}</p>
            </div>
          </div>
        )}

        <form id="leaveTypeForm" onSubmit={handleSubmit}>
          <div className="form-section-card theme-blue" style={{ marginBottom: '24px' }}>
            <div className="section-header" style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px', paddingBottom: '16px', borderBottom: '1px solid #f1f5f9' }}>
              <div className="section-icon" style={{ background: '#e0e7ff', color: '#4f46e5', width: '40px', height: '40px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px' }}>
                <FaCalendarAlt />
              </div>
              <h2 style={{ margin: 0, fontSize: '18px', color: '#1e293b' }}>Leave Type Details</h2>
            </div>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '15px'
            }}>
              {isFieldVisible('leave_code') && (
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2c3e50' }}>Leave Code</label>
                <input
                  type="text"
                  placeholder="e.g., PL, CL, SL"
                  value={form.leave_code}
                  onChange={(e) => setForm({ ...form, leave_code: e.target.value.toUpperCase() })}
                  required
                  maxLength={10}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #e9ecef',
                    borderRadius: '10px',
                    fontSize: '1rem',
                    background: '#f8f9fa',
                    textTransform: 'uppercase'
                  }}
                />
              </div>
              )}
              {isFieldVisible('leave_name') && (
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2c3e50' }}>Leave Name</label>
                <input
                  type="text"
                  placeholder="e.g., Paid Leave, Casual Leave"
                  value={form.leave_name}
                  onChange={(e) => setForm({ ...form, leave_name: e.target.value })}
                  required
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #e9ecef',
                    borderRadius: '10px',
                    fontSize: '1rem',
                    background: '#f8f9fa'
                  }}
                />
              </div>
              )}
              {isFieldVisible('is_paid') && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input
                  type="checkbox"
                  id="is_paid"
                  checked={form.is_paid}
                  onChange={(e) => setForm({ ...form, is_paid: e.target.checked })}
                />
                <label htmlFor="is_paid" style={{ fontWeight: '500', color: '#2c3e50' }}>Paid Leave (No salary cut)</label>
              </div>
              )}
              {isFieldVisible('allow_half_day') && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input
                  type="checkbox"
                  id="allow_half_day"
                  checked={form.allow_half_day}
                  onChange={(e) => setForm({ ...form, allow_half_day: e.target.checked })}
                />
                <label htmlFor="allow_half_day" style={{ fontWeight: '500', color: '#2c3e50' }}>Allow Half Day (0.5 day)</label>
              </div>
              )}
              {isFieldVisible('allow_hourly') && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input
                  type="checkbox"
                  id="allow_hourly"
                  checked={form.allow_hourly}
                  onChange={(e) => setForm({ ...form, allow_hourly: e.target.checked })}
                />
                <label htmlFor="allow_hourly" style={{ fontWeight: '500', color: '#2c3e50' }}>Allow Hourly Leave</label>
              </div>
              )}
              {isFieldVisible('is_active') && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input
                  type="checkbox"
                  id="is_active"
                  checked={form.is_active}
                  onChange={(e) => setForm({ ...form, is_active: e.target.checked })}
                />
                <label htmlFor="is_active" style={{ fontWeight: '500', color: '#2c3e50' }}>Active</label>
              </div>
              )}
            </div>
            {isFieldVisible('description') && (
            <div style={{ marginTop: '15px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#2c3e50' }}>Description (Optional)</label>
              <textarea
                placeholder="Enter detailed description..."
                value={form.description}
                onChange={(e) => setForm({ ...form, description: e.target.value })}
                rows="3"
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #e9ecef',
                  borderRadius: '10px',
                  fontSize: '1rem',
                  background: '#f8f9fa',
                  resize: 'vertical'
                }}
              />
            </div>
            )}


            
          </div>
        </form>
        </div>
        {/* Table */}
        {leaveTypes.length > 0 ? (
          <div className="premium-table-wrapper" style={{ marginTop: '30px' }}>
            <table className="premium-table" style={{ width: '100%' }}>
              <thead>
                <tr>
                  {isFieldVisible('leave_code') && <th>Code</th>}
                  {isFieldVisible('leave_name') && <th>Name</th>}
                  {isFieldVisible('company') && <th>Companies</th>}
                  {isFieldVisible('branch') && <th>Branches</th>}
                  {isFieldVisible('is_paid') && <th style={{ textAlign: 'center' }}>Paid</th>}
                  {isFieldVisible('allow_half_day') && <th style={{ textAlign: 'center' }}>Half Day</th>}
                  {isFieldVisible('allow_hourly') && <th style={{ textAlign: 'center' }}>Hourly</th>}
                  {isFieldVisible('is_active') && <th style={{ textAlign: 'center' }}>Status</th>}
                  <th style={{ textAlign: 'center' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {leaveTypes.map((type, index) => (
                  <tr key={type.leave_type_id || type._id}>
                    {isFieldVisible('leave_code') && <td>{type.leave_code}</td>}
                    {isFieldVisible('leave_name') && <td>{type.leave_name}</td>}
                    {isFieldVisible('company') && <td className="bold-text">{(type.company_names || (type.company_name ? [type.company_name] : [])).join(', ') || 'All'}</td>}
                    {isFieldVisible('branch') && <td className="bold-text">{(type.branch_names || (type.branch_name ? [type.branch_name] : [])).join(', ') || 'All Branches'}</td>}
                    {isFieldVisible('is_paid') && <td style={{ textAlign: 'center' }}>{type.is_paid ? 'Yes' : 'No'}</td>}
                    {isFieldVisible('allow_half_day') && <td style={{ textAlign: 'center' }}>{type.allow_half_day ? 'Yes' : 'No'}</td>}
                    {isFieldVisible('allow_hourly') && <td style={{ textAlign: 'center' }}>{type.allow_hourly ? 'Yes' : 'No'}</td>}
                    {isFieldVisible('is_active') && <td style={{ textAlign: 'center' }}>
                      <span className={`status-badge ${type.is_active ? 'active' : 'inactive'}`}>
                        {type.is_active ? 'Active' : 'Inactive'}
                      </span>
                    </td>}
                    <td>
                      <div className="action-buttons">
                        <button
                          onClick={() => handleEdit(type)}
                          className="action-btn edit"
                          title="Edit"
                        >
                          <FaEdit />
                        </button>
                        <button
                          onClick={() => handleDelete(type.leave_type_id || type._id)}
                          className="action-btn delete"
                          title="Delete"
                          disabled={loading}
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ marginTop: '20px', paddingLeft: '10px' }}>
            <h2 style={{ fontSize: '18px', color: '#1e293b', margin: 0, fontWeight: '600' }}>Type List</h2>
          </div>
        )}
      </div>
      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}
          onClick={closeDeleteConfirm}
        >
          <div style={{
            backgroundColor: '#ffffff',
            padding: '30px',
            borderRadius: '15px',
            width: '90%',
            maxWidth: '400px',
            boxShadow: '0 10px 20px rgba(0, 0, 0, 0.2)',
            textAlign: 'center',
            border: '1px solid #e9ecef'
          }}>
            <h3 style={{
              color: '#e74c3c',
              marginBottom: '15px',
              fontSize: '1.5rem'
            }}>
              <FaTrash style={{ fontSize: '1.5rem', marginRight: '10px' }} />
              Confirm Delete
            </h3>
            <p style={{
              color: '#2c3e50',
              marginBottom: '25px',
              fontSize: '1.1rem',
              lineHeight: '1.5'
            }}>Are you sure you want to delete this leave type? This action cannot be undone.</p>
            <div style={{
              display: 'flex',
              gap: '15px',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              <button
                onClick={confirmDelete}
                style={{
                  padding: '12px 24px',
                  background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '25px',
                  cursor: 'pointer',
                  fontSize: '1rem',
                  fontWeight: '600',
                  boxShadow: '0 4px 8px rgba(231, 76, 60, 0.3)',
                  transition: 'all 0.3s ease',
                  minWidth: '120px'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 12px rgba(231, 76, 60, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 8px rgba(231, 76, 60, 0.3)';
                }}
                disabled={loading}
              >
                {loading ? 'Deleting...' : 'Yes, Delete'}
              </button>
              <button
                onClick={closeDeleteConfirm}
                style={{
                  padding: '12px 24px',
                  background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '25px',
                  cursor: 'pointer',
                  fontSize: '1rem',
                  fontWeight: '600',
                  boxShadow: '0 4px 8px rgba(52, 152, 219, 0.3)',
                  transition: 'all 0.3s ease',
                  minWidth: '120px'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 12px rgba(52, 152, 219, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 8px rgba(52, 152, 219, 0.3)';
                }}
                disabled={loading}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <CustomerCustomizationModal
        isOpen={showCustomizeModal}
        onClose={() => setShowCustomizeModal(false)}
        onRefresh={handleCustomizationRefresh}
        targetDocType="Leave Type"
      />

      {/* Assign Companies & Branches Modal */}
      {showAssignModal && (
        <div className="add-modal-overlay" onClick={() => setShowAssignModal(false)}>
          <div className="add-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '600px' }}>
            <div className="modal-header">
              <span>
                <FaBuilding style={{ fontSize: '20px' }} /> 
                Assign Companies & Branches
              </span>
              <button className="close-modal-btn" onClick={() => setShowAssignModal(false)}>
                <FaTimes />
              </button>
            </div>
            
            <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
              {showCompanyAssign && (
                <div style={{ marginBottom: '24px' }}>
                  <p>Select Companies</p>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
                    {allCompanies.map((comp, idx) => {
                      const isSelected = selectedCompanies.includes(comp);
                      return (
                        <div key={idx} style={{ border: isSelected ? '2px solid #604be8' : '2px solid #e2e8f0', padding: '12px 16px', borderRadius: '14px', backgroundColor: isSelected ? '#f5f3ff' : '#f8fafc', cursor: 'pointer', transition: 'all 0.2s' }} onClick={() => {
                          if (isSelected) setSelectedCompanies(prev => prev.filter(c => c !== comp));
                          else setSelectedCompanies(prev => [...prev, comp]);
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <input type="checkbox" checked={isSelected} readOnly style={{ width: '18px', height: '18px', accentColor: '#604be8', cursor: 'pointer' }} />
                            <span style={{ fontWeight: '600', color: '#1e293b', fontSize: '14px' }}>{comp}</span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {showBranchAssign && selectedCompanies.length > 0 && availableBranches.length > 0 && (
                <div>
                  <p>Select Branches</p>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
                    {availableBranches.map((branch, idx) => {
                      const isSelected = selectedAddBranches.includes(branch);
                      return (
                        <div key={idx} style={{ border: isSelected ? '2px solid #604be8' : '2px solid #e2e8f0', padding: '12px 16px', borderRadius: '14px', backgroundColor: isSelected ? '#f5f3ff' : '#f8fafc', cursor: 'pointer', transition: 'all 0.2s' }} onClick={() => {
                          if (isSelected) setSelectedAddBranches(prev => prev.filter(b => b !== branch));
                          else setSelectedAddBranches(prev => [...prev, branch]);
                        }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <input type="checkbox" checked={isSelected} readOnly style={{ width: '18px', height: '18px', accentColor: '#604be8', cursor: 'pointer' }} />
                            <span style={{ fontWeight: '600', color: '#1e293b', fontSize: '14px' }}>{branch}</span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button className="cancel-btn" onClick={() => setShowAssignModal(false)} style={{ background: '#f1f5f9', color: '#64748b' }}>
                Cancel
              </button>
              <button className="save-btn" onClick={processSubmit} disabled={loading} style={{ background: '#604be8' }}>
                {loading ? 'Saving...' : 'Confirm & Save'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeaveType;
